import { MaintenancePlanUtils } from "../util/maintenance-plan.utils";
import { ActivityTask, TaskStatus } from "./activity-task.model";
import { RecurrenceType } from "./enums/recurrence-type.enum";
import { RecurrenceUnit } from "./enums/recurrence-unit.enum";
import { Recurrence } from "./recurrence.model";

export class TicketOperationRecurrences {

    public id: number;
    public recurrence: Recurrence;

    constructor(ticketOperationRecurrence: any = {}) {
        if (!ticketOperationRecurrence) {
            return new TicketOperationRecurrences();
        }
        this.id = ticketOperationRecurrence.id || 0;
        this.recurrence = MaintenancePlanUtils.mapRecurrence(ticketOperationRecurrence.recurrence);
    }

    static get type() {
        return 'ticket-operation-recurrences';
    }
}
